const TemplateService = {
  async saveTemplate(formData) {
    try {
      let url = '/api/wod/template';
      let method = 'POST';
      const profileLogged = JSON.parse(localStorage.getItem('profile'));
      const { accountIdentifier } = profileLogged;
      if (formData.identifier !== undefined) {
        url = '/api/wod/template/' + formData.identifier;
        method = 'PUT';
      }

      const updatedData = {
        ...formData,
        accountIdentifier: accountIdentifier,
        days: formData.days.map(day => {
          if (day.pristine) {
            const { identifier, ...rest } = day;
            return rest;
          }
          return day;
        })
      };
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedData)
      });
      if (response.ok) {
        const newTemplate = await response.json();
        console.log('Template has been updated:', newTemplate);
      }
    } catch (error) {
      console.log('Error saving Template', error);
    }
  },
  async retrieveAllTemplatesByAccount() {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      console.log(accountIdentifier);
      const response = await fetch(
        '/api/wod/template/account/' + accountIdentifier
      );
      const data = await response.json();
      const updatedData = data.map(d => ({
        ...d,
        startDate: this.convertDate(d.startDate),
        endDate: this.convertDate(d.endDate),
        startTime: this.convertTime(d.startTime),
        endTime: this.convertTime(d.endTime)
      }));
      return updatedData;
    } catch (error) {
      console.error('Error fetching Template', error);
      throw error;
    }
  },
  async importTemplate(row) {
    console.log('Row:', row);
    const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
    const url =
      '/api/wod/template/account/' + accountIdentifier + '/import';
    const method = 'POST';
    const history = {
      name: row.name,
      startDate: row.startDate,
      endDate: row.endDate,
      startTime: row.startTime,
      endTime: row.endTime,
      dayOfWeek: row.dayOfWeek,
      coach: row.coach,
      room: row.room,
      color: row.color,
      maxCapacity: row.maxCapacity,
      cancellationPolicyHours: row.cancellationPolicyHours
    };
    console.log(history);
    try {
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(history)
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error importing history', error);
      throw error;
    }
  },  
  convertTime(time) {
    const hour = time[0] < 10 ? '0' + time[0] : time[0];
    const min = time[1] < 10 ? '0' + time[1] : time[1];
    return hour + ':' + min;
  },
  convertDate(date) {
    console.log(date);
    const year = date[0];
    const month = date[1] < 10 ? '0' + date[1] : date[1];
    const day = date[2] < 10 ? '0' + date[2] : date[2];
    console.log(year + '-' + month + '-' + day);
    return year + '-' + month + '-' + day;
  },
  async retrieveTemplate(identifier) {
    try {
      const response = await fetch('/api/wod/template/' + identifier);
      const data = await response.json();
      const updatedData = {
        ...data,
        startDate: this.convertDate(data.startDate),
        endDate: this.convertDate(data.endDate),
        startTime: this.convertTime(data.startTime),
        endTime: this.convertTime(data.endTime)
      };
      return updatedData;
    } catch (error) {
      console.error('Error fetching Template', error);
      throw error;
    }
  },
  async deleteTemplate(identifier) {
    try {
      let url = '/api/wod/template/' + identifier;
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const newTemplate = await response.json();
        console.log('Template has been deleted:', newTemplate);
      }
    } catch (error) {
      console.log('Error deleting Template', error);
    }
  },
  async createClassesFromTemplate(identifier) {
    try {
      // Fetch the template
      const template = await this.retrieveTemplate(identifier);
      
      // Parse start and end dates
      const startDate = new Date(template.startDate);
      const endDate = new Date(template.endDate);
      
      // Map day names to JavaScript day numbers (0 = Sunday, 1 = Monday, etc.)
      const dayMap = {
        'SUNDAY': 0,
        'MONDAY': 1,
        'TUESDAY': 2,
        'WEDNESDAY': 3,
        'THURSDAY': 4,
        'FRIDAY': 5,
        'SATURDAY': 6
      };
      
      // Create a map of day numbers to day configuration
      const dayConfigMap = {};
      template.days.forEach(day => {
        const dayNum = dayMap[day.dayOfWeek];
        dayConfigMap[dayNum] = day;
      });
      
      // Generate all wodclasses
      const wodClasses = [];
      const currentDate = new Date(startDate);
      
      while (currentDate <= endDate) {
        const dayOfWeek = currentDate.getDay();
        
        // If this day of the week is in the template
        if (dayConfigMap[dayOfWeek]) {
          const dayConfig = dayConfigMap[dayOfWeek];
          
          // Format date as YYYY-MM-DD
          const year = currentDate.getFullYear();
          const month = String(currentDate.getMonth() + 1).padStart(2, '0');
          const day = String(currentDate.getDate()).padStart(2, '0');
          const dateString = `${year}-${month}-${day}`;
          
          // Create wodclass object
          const wodClass = {
            name: template.name,
            accountIdentifier: template.accountIdentifier,
            templateIdentifier: identifier,
            date: dateString,
            startTime: template.startTime,
            endTime: template.endTime,
            coach: dayConfig.coach,
            room: dayConfig.room,
            color: dayConfig.color,
            maxCapacity: dayConfig.maxCapacity,
            cancellationPolicyHours: dayConfig.cancellationPolicyHours
          };
          
          wodClasses.push(wodClass);
        }
        
        // Move to next day
        currentDate.setDate(currentDate.getDate() + 1);
      }
      
      // Send all wodclasses to the API
      console.log('WodClasses to sent', wodClasses);
      const response = await fetch('/api/wod/wodclass/all', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(wodClasses)
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log(`Created ${wodClasses.length} classes successfully:`, result);
        return { success: true, count: wodClasses.length, data: result };
      } else {
        throw new Error('Failed to create classes');
      }
    } catch (error) {
      console.error('Error creating classes from template:', error);
      throw error;
    }
  },
  async deleteClasses(type, from, to) {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      const url = `/api/wod/wodclass/account/${accountIdentifier}/type/${type}/${from}/${to}`;
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const result = await response.json();
        console.log('Classes deleted successfully:', result);
        return { success: true, data: result };
      } else {
        throw new Error('Failed to delete classes');
      }
    } catch (error) {
      console.error('Error deleting classes:', error);
      throw error;
    }
  },
  async deleteClassesFromTemplate(identifier, from, to) {
    try {
      const { accountIdentifier } = JSON.parse(localStorage.getItem('profile'));
      const url = `/api/wod/wodclass/account/${accountIdentifier}/template/${identifier}/${from}/${to}`;
      const response = await fetch(url, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const result = await response.json();
        console.log('Classes deleted successfully:', result);
        return { success: true, data: result };
      } else {
        throw new Error('Failed to delete classes');
      }
    } catch (error) {
      console.error('Error deleting classes:', error);
      throw error;
    }
  }  
};
export default TemplateService;
